import { foldMarketplaceProduct } from "../types/MarketplaceProduct";
export default (function (product) {
  return foldMarketplaceProduct(product)(function () {
    return 'Jira';
  }, function () {
    return 'Confluence';
  });
});